<template>
  <div class="container flex-center" :style="'--highlight-color: '+ company.highlight +';'">
    <div class="card card__md">
      <button
        @click="$router.go(-1)"
        class="button button__rounded button__return"
      >
        <span>Palaa takaisin</span>
      </button>
      <h3>Muokkaa yrityksen tietoja</h3>
      <form
        v-if="company"
        @submit.prevent="editCompany"
        class="edit-company__form"
      >
        <base-input
          type="text"
          name="name"
          label="Yrityksen nimi (ei muokattavissa)"
          :disabled="true"
          v-model="company.name"
          :errors="errors.name"
        />
        <LogoUpload
          :company="company.id"
          @status-updated="onFileStatusUpdated"
        />
        <ColorPicker
          :defaultColor="company.highlight"
          v-model="company.highlight"
        />
        <transition-group
          v-if="company.categories.length"
          name="list"
          class="categories"
          tag="ul"
          mode="out-in"
        >
          <li
            v-for="category in company.categories"
            :key="category.title"
            :style="{ backgroundColor: category.background }"
          >
            {{ category.title }}
            <span class="delete" @click="deleteCategory(category)"></span>
          </li>
        </transition-group>
        <span class="field__error error" v-visible="categoryError != ''">{{categoryError}}</span>
        <base-input
          type="text"
          name="category"
          label="Lisää kategoria"
          v-model="newCategory.title"
          @onClick="addCategory"
          button="Lisää kategoria"
          :blue="true"
          :errors="errors.category"
        />
        <div class="company-users" v-if="userIsAdmin">
          <h4>Käyttäjät</h4>
          <ol class="company-users__username">
            <li v-for="user in companyUsers" :key="user.id">
              {{ user.username }}
            </li>
          </ol>
        </div>
        <button type="submit" class="button button__rounded button__submit" :disabled="uploading">
          <span>Päivitä yrityksen tiedot</span>
        </button>
      </form>
    </div>
    <div class="spinner" v-if="uploading">
      <Loader />
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import { mapState } from "vuex";

import BaseInput from "@/components/BaseInput";
import LogoUpload from "@/components/LogoUpload";
import ColorPicker from "@/components/ColorPicker";

export default {
  name: "EditCompany",
  components: {
    BaseInput,
    LogoUpload,
    ColorPicker
  },
  data() {
    return {
      company: null,
      categories: [],
      users: [],
      sortedUsers: [],
      newCategory: {},
      colors: ["#2677c2", "#26c285", "#ece34d", "#fcb039", "#fc553a"],
      used: false,
      errors: {},
      categoryError: '',
      uploading: false,
      logoUrl: null,
      color: ''
    };
  },
  created() {
    this.company = this.companies[this.$route.params.companyId];

    if (this.$route.params && this.$route.params.companyId) {
      this.$store.commit("SET_COMPANY_BY_ID", this.$route.params.companyId);
    } else {
      this.$store.commit("SET_DEFAULT_COMPANY");
    }

    if (this.company.name === "DNA") {
      this.colors = ["#ff007d", "#ffa100", "#007d91", "#4b5055"];
    }

    if (this.userIsAdmin) {
      db.collection("users")
        .get()
        .then(snapshot => {
          this.users = [];
          snapshot.forEach(doc => {
            let user = doc.data();
            user.id = doc.id;
            this.users.push(user);
          });
        });
    }
    // db.collection("users")
    //   .get()
    //   .then(snapshot => {
    //     this.users = [];
    //     snapshot.forEach(doc => {
    //       let user = doc.data();
    //       user.id = doc.id;
    //       this.users.push(user);
    //     });
    //   });
    // let ref = db
    //   .collection("companies")
    //   .where("slug", "==", this.$route.params.companyId);
    // ref.get().then(snapshot => {
    //   snapshot.forEach(doc => {
    //     this.company = doc.data();
    //     this.company.id = doc.id;
    //   });
    // });
  },
  computed: {
    ...mapState(["user", "companies", "userIsAdmin"]),

    companyUsers() {
      const users = this.users.map(usr => usr);

      console.log(this.users);

      const equal = users.some(u => {
        if (this.company.id === u.companyId) {
          this.sortedUsers.push(u);
        }
        return equal;
      });

      return this.sortedUsers;
    },
  },
  methods: {
    editCompany() {
      if (this.company.name) {
        // this.company.id = slugify(this.company.name, {
        //   replacement: "-",
        //   remove: /[$*_+~()'"!\-:@]/g,
        //   lower: true,
        // });
        console.log(this.logoUrl);

        const editedCompany = {
          id: this.company.id,
          name: this.company.name,
          image: this.logoUrl ? this.logoUrl : this.company.image,
          categories: this.company.categories,
          highlight: this.company.highlight
        };

        db.collection("companies")
          .doc(this.company.id)
          .update(editedCompany)
          .then(() => {
            if (!this.userIsAdmin) {
              this.$router.push({
                name: "IndexCompany",
                params: { companyId: this.company.id },
              });
            } else {
              this.$router.push({ name: "Admin" });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    getNextFreeColor() {
      if (this.company.categories.length > 0) {
        for (let i = 0; i < this.colors.length; i++) {
          this.used = false;
          for (let j = 0; j < this.company.categories.length; j++) {
            if (this.colors[i] === this.company.categories[j].background) {
              this.used = true;
              break;
            }
          }
          if (!this.used) {
            this.color = this.colors[i];
            break;
          }
        }
      } else {
        this.color = this.colors[0];
      }
      return this.color;
    },
    addCategory() {
      if (this.newCategory.title) {
        this.newCategory = {
          title: this.newCategory.title,
          background: this.getNextFreeColor(),
        };
        this.company.categories.push(this.newCategory);
        console.log(this.company.categories);
        this.newCategory = {};
        this.errors.category = null;
      } else {
        this.errors.category = "Virhe.";
      }
    },
    onFileStatusUpdated(status) {
      if(status.status == "uploading") {
        this.uploading = true;
      }
      if(status.url) {
        this.logoUrl = status.url;
        this.uploading = false;
      }
    },
    deleteCategory(category) {
      this.categoryError = "";
      db.collection(`companies/${this.company.id}/events`)
      .get()
      .then((querySnapshot) => {
        const snapshotsArray = querySnapshot.docs;
        let categoryEmpty = true;

        for (var i = 0; i < snapshotsArray.length; i++) {
          const data = snapshotsArray[i].data()
          if(data.category.title == category.title) {
            this.categoryError = "Kategoria sisältää tapahtumia.";
            categoryEmpty = false;
            break;
          }
        }
        if(categoryEmpty) {
          this.company.categories = this.company.categories.filter(cat => {
            return cat !== category;
          });
        }
      })
      .catch(err => {
        console.log(err);
      });

    },
  },
};
</script>

<style lang="scss">
.card {
  position: relative;

  .spinner {
    border-radius: 1.5rem;
    margin: auto;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #44444473;
  }
}
.error {
  transition: $transition;
  display: block;
  height: 18px;
}
.company-users {
  display: flex;
  flex-direction: column;
  &__username {
    padding-left: 1rem;
    li {
      position: relative;
      margin: 0.5rem 0;
      padding: 0.5rem 0;
      font-size: 1.6rem;
      &:after {
        content: "";
        position: absolute;
        left: -1rem;
        bottom: 0;
        width: calc(100% + 1rem);
        height: 1px;
        background: $gray;
      }
    }
  }
}
</style>
